var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7957 12.8354C35.8404 12.8354 42.3622 19.2984 42.3622 27.2705C42.3622 35.2426 35.8404 41.7055 27.7957 41.7055C19.7509 41.7055 13.2291 35.2426 13.2291 27.2705C13.2255 19.2984 19.7473 12.8354 27.7957 12.8354ZM44.5993 26.6098H44.6065C44.592 26.2595 44.5701 25.9129 44.5337 25.5663L44.53 25.5446L44.5264 25.523C43.6884 17.049 36.5144 10.4236 27.792 10.4236C19.0732 10.4236 11.9029 17.0381 11.0576 25.5085L11.054 25.5302L11.0503 25.5519L11.0467 25.5735C11.0103 25.9165 10.9884 26.2595 10.9738 26.6061H10.9811C10.9738 26.7975 10.9702 26.9925 10.9702 27.1875L10.9738 27.4294H10.9629C10.9665 27.8807 10.9884 28.3248 11.0285 28.7653L11.043 28.7617C11.0686 29.0361 11.1013 29.3105 11.1414 29.5813L11.1232 29.5849C11.1888 30.047 11.2726 30.4983 11.3746 30.9461L11.3965 30.9388C11.4584 31.2096 11.5276 31.4732 11.6005 31.7404L11.5786 31.7476C11.6989 32.1809 11.841 32.6105 11.9976 33.0293L12.0231 33.0185C12.1179 33.2749 12.2235 33.5312 12.3328 33.784L12.3073 33.7948C12.4931 34.2244 12.6935 34.6433 12.9121 35.0549L12.934 35.0404C13.0652 35.2823 13.2 35.5243 13.3421 35.7589L13.3202 35.7734C13.5534 36.1633 13.8011 36.5424 14.0635 36.9071L14.0817 36.8927C14.242 37.1165 14.4096 37.3368 14.5808 37.5534L14.5626 37.5678C14.8541 37.9361 15.1601 38.2899 15.4808 38.6293L15.4953 38.6149C15.6848 38.8171 15.8779 39.0157 16.0783 39.207L16.0637 39.2215C16.3916 39.5392 16.7341 39.8425 17.0875 40.1313L17.0948 40.1205C17.3061 40.2938 17.5248 40.4671 17.747 40.6296L17.7397 40.6404C18.1186 40.922 18.5121 41.1856 18.9129 41.4347L18.9166 41.4275C19.1497 41.572 19.3902 41.7128 19.6307 41.8464L19.627 41.8536C20.0278 42.0738 20.4395 42.2796 20.8585 42.4674V42.4638C21.1099 42.5757 21.3686 42.684 21.6273 42.7851C21.8678 42.879 22.1119 42.9656 22.356 43.0523L22.3778 43.0595L22.3997 43.0667L22.4216 43.074L22.4434 43.0812L22.4653 43.0884L22.4871 43.0956L22.6766 43.157L22.6985 43.1642L22.7203 43.1714L22.7422 43.1786L22.8478 43.2112L22.8697 43.2184L22.8916 43.2256L22.9134 43.2328L22.9353 43.24L22.9571 43.2472L22.979 43.2545C24.5056 43.7094 26.1233 43.9549 27.7993 43.9549C29.4753 43.9549 31.093 43.7094 32.6196 43.2545L32.6414 43.2472L32.6633 43.24L32.6852 43.2328L32.8928 43.1714L32.9147 43.1642L32.9366 43.157L32.9584 43.1498L33.0604 43.1173L33.0823 43.1101L33.1042 43.1028L33.126 43.0956L33.1479 43.0884L33.1697 43.0812L33.2463 43.0559H33.2499L33.2718 43.0487C33.4977 42.9729 33.7199 42.8934 33.9385 42.8068C34.1972 42.7057 34.4522 42.601 34.7073 42.4854V42.489C35.1409 42.2941 35.5671 42.0847 35.9789 41.8572L35.9752 41.85C36.2157 41.7164 36.4561 41.5756 36.6893 41.4311L36.693 41.4384C37.0828 41.1965 37.4617 40.9401 37.8297 40.6729L37.8224 40.6621C38.0447 40.496 38.2633 40.3263 38.4783 40.153L38.4892 40.1638C38.8535 39.8678 39.2069 39.5536 39.5458 39.2287L39.5312 39.2143C39.7316 39.0229 39.9247 38.8243 40.1142 38.6221L40.1287 38.6366C40.4384 38.3044 40.7372 37.9614 41.0214 37.6075L41.0032 37.5931C41.1744 37.3765 41.342 37.1598 41.5023 36.936L41.5205 36.9504C41.7938 36.5713 42.0525 36.1814 42.293 35.777L42.2711 35.7626C42.4132 35.5279 42.548 35.2859 42.6755 35.044L42.6974 35.0585C42.9087 34.6613 43.1054 34.2533 43.284 33.8381L43.2585 33.8273C43.3678 33.5745 43.4734 33.3182 43.5682 33.0618L43.5937 33.0727C43.7576 32.6394 43.8997 32.1989 44.0272 31.7512L44.0054 31.744C44.0819 31.4804 44.1475 31.2132 44.2094 30.9424L44.2313 30.9497C44.3296 30.5164 44.4098 30.0759 44.4754 29.6282L44.4572 29.6246C44.4972 29.3538 44.53 29.083 44.5555 28.8086L44.5701 28.8122C44.6138 28.3573 44.6357 27.8951 44.6393 27.433H44.6284L44.6321 27.1911C44.6102 26.9961 44.6066 26.8047 44.5993 26.6098Z",
    fill: "#FBBB20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 26.4332C0.0218607 25.4872 0.0910863 24.552 0.207677 23.6313L1.85452 23.848C1.74886 24.6965 1.67963 25.5594 1.66141 26.4332H0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1612 44.3665L17.9191 43.0667C17.4236 42.7634 16.9426 42.4421 16.4799 42.0955L15.5581 43.2833C16.0718 43.6697 16.6074 44.0307 17.1612 44.3665Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5216 45.5978L20.1009 44.2113C19.5836 43.9839 19.0808 43.7311 18.5889 43.4603L17.8311 44.7601C18.3812 45.0634 18.946 45.345 19.5216 45.5978Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0788 46.5261L22.4722 45.0783C21.9112 44.9158 21.361 44.728 20.8254 44.515L20.2461 45.8979C20.8436 46.1362 21.4557 46.3456 22.0788 46.5261Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6888 47.0964L24.8892 45.6125C24.3281 45.5258 23.7743 45.4139 23.2277 45.2803L22.8379 46.7281C23.4427 46.8798 24.0621 47.0025 24.6888 47.0964Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3661 47.9556L27.3806 46.2117C26.794 46.1973 26.2147 46.1539 25.6427 46.0781L25.4277 47.8076C26.0653 47.8942 26.7139 47.9412 27.3661 47.9556Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0548 46.8004L29.858 45.3129C29.3006 45.3742 28.7359 45.4104 28.1675 45.4212V46.9196C28.8014 46.9087 29.4318 46.8654 30.0548 46.8004Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.758 46.7281L32.3645 45.2803C31.8035 45.4175 31.2351 45.533 30.6558 45.6197L30.8525 47.1072C31.4974 47.0097 32.1314 46.8834 32.758 46.7281Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3013 45.9193L34.7257 44.5328C34.201 44.7386 33.6691 44.9192 33.1226 45.078L33.516 46.5259C34.1209 46.349 34.7147 46.1468 35.3013 45.9193Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7577 44.7601L36.9998 43.4603C36.4934 43.742 35.976 43.9983 35.4404 44.233L36.0161 45.6194C36.6173 45.3595 37.1966 45.0706 37.7577 44.7601Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9945 43.3195L39.0763 42.1281C38.6245 42.4602 38.1582 42.7743 37.6772 43.0668L38.4351 44.3666C38.9707 44.0416 39.4917 43.6914 39.9945 43.3195Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0606 41.5687L40.9895 40.5072C40.5741 40.908 40.1442 41.2907 39.6924 41.6518L40.6105 42.8432C41.1133 42.4389 41.5979 42.0128 42.0606 41.5687Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8386 39.6044L42.6399 38.6909C42.2937 39.1278 41.9258 39.5502 41.5396 39.9546L42.6107 41.0161C43.0407 40.5612 43.4487 40.0918 43.8386 39.6044Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6729 47.6272L19.2267 46.3129C18.6183 46.0458 18.0244 45.7497 17.4487 45.4283L16.731 46.6632C17.3576 47.0134 18.0062 47.3347 18.6729 47.6272Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5072 48.6484L21.8789 47.2728C21.2194 47.0851 20.5745 46.8612 19.9442 46.6121L19.394 47.9263C20.0827 48.2007 20.7858 48.4426 21.5072 48.6484Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3963 49.2737L24.5858 47.862C23.9226 47.7609 23.2741 47.6309 22.6329 47.472L22.2612 48.8477C22.9608 49.0246 23.6712 49.169 24.3963 49.2737Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3431 50.5117L27.3577 48.8545C26.669 48.84 25.9877 48.7895 25.3173 48.6992L25.1133 50.342C25.8456 50.4431 26.5889 50.4973 27.3431 50.5117Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3177 48.613L30.1319 47.2013C29.4761 47.2735 28.813 47.3168 28.1426 47.3277V48.7502C28.8786 48.7394 29.6036 48.6925 30.3177 48.613Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3299 48.8508L32.9582 47.4752C32.3024 47.6377 31.632 47.7713 30.9507 47.8724L31.1365 49.2841C31.8798 49.1722 32.6121 49.0278 33.3299 48.8508Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.146 47.9486L35.5995 46.6307C34.9837 46.8726 34.3571 47.0857 33.7158 47.2698L34.0875 48.6454C34.787 48.4468 35.472 48.2122 36.146 47.9486Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.869 46.6627L38.1513 45.4315C37.5574 45.7601 36.9489 46.0634 36.3223 46.3378L36.8724 47.6556C37.5538 47.3523 38.2205 47.0238 38.869 46.6627Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3423 45.0634L40.4716 43.9333C39.9432 44.3269 39.3931 44.6952 38.8247 45.0382L39.5425 46.273C40.1619 45.8975 40.763 45.4931 41.3423 45.0634Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6269 43.1208L42.6104 42.1134C42.1258 42.5864 41.6157 43.0341 41.0874 43.4565L41.9618 44.5866C42.5411 44.1245 43.0949 43.6335 43.6269 43.1208Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.594 40.9405L44.4572 40.074C44.0492 40.5903 43.6156 41.0849 43.1602 41.5615L44.1767 42.5689C44.6722 42.049 45.1458 41.5074 45.594 40.9405Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2884 38.4817L46.0424 37.7704C45.6962 38.3517 45.3246 38.9149 44.9238 39.4565L46.0642 40.3231C46.5014 39.7345 46.9095 39.1171 47.2884 38.4817Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7846 49.7466L18.3748 48.3385C17.6789 48.0352 16.9976 47.6958 16.3381 47.3275L15.5693 48.6454C16.2835 49.0498 17.0231 49.418 17.7846 49.7466Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9061 50.8655L21.3033 49.396C20.5491 49.1793 19.8131 48.9302 19.0917 48.6414L18.5015 50.0495C19.2848 50.36 20.0864 50.6308 20.9061 50.8655Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0901 51.5515L24.2941 50.0422C23.5363 49.9303 22.793 49.7823 22.0607 49.5981L21.6636 51.0676C22.4578 51.2662 23.2667 51.4287 24.0901 51.5515Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.323 53.1838L27.3375 51.411C26.5505 51.3966 25.7708 51.3352 25.0057 51.2341L24.7871 52.9889C25.6215 53.1044 26.4667 53.1694 27.323 53.1838Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.576 50.6526L30.3756 49.1434C29.6287 49.2265 28.8672 49.277 28.1021 49.2879V50.8115C28.9364 50.8007 29.7635 50.7465 30.576 50.6526Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9308 51.0676L33.5337 49.5981C32.7831 49.7859 32.018 49.9375 31.2383 50.0495L31.4387 51.5587C32.2803 51.4359 33.1147 51.2734 33.9308 51.0676Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0287 50.0715L36.4421 48.6633C35.7389 48.9413 35.0211 49.1833 34.2852 49.3927L34.6823 50.8658C35.4839 50.6383 36.2672 50.3747 37.0287 50.0715Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0266 48.6486L39.2578 47.3307C38.5802 47.7098 37.8806 48.0528 37.1665 48.3633L37.7531 49.7714C38.5292 49.4357 39.2906 49.0602 40.0266 48.6486Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2624 44.7425L44.1766 43.6665C43.6228 44.2045 43.0399 44.7172 42.4351 45.201L43.3678 46.4105C44.0272 45.887 44.6612 45.331 45.2624 44.7425Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4305 42.3412L46.2136 41.4133C45.7472 42.0055 45.2517 42.5723 44.7271 43.1139L45.8128 44.1899C46.3812 43.6013 46.9204 42.9839 47.4305 42.3412Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2923 39.6299L47.9624 38.868C47.569 39.5324 47.139 40.1751 46.6836 40.7961L47.9005 41.724C48.3997 41.0524 48.866 40.3556 49.2923 39.6299Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7701 53.9525C22.8411 53.8152 21.9266 53.6347 21.0303 53.4109L21.4602 51.8186C22.2873 52.028 23.1325 52.1941 23.9888 52.3205L23.7701 53.9525Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2964 56.0001C26.3309 55.9856 25.3763 55.9098 24.4399 55.7834L24.6768 53.8843C25.5439 54.0034 26.422 54.0684 27.3146 54.0865L27.2964 56.0001Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8776 52.8299C29.9594 52.9346 29.0303 52.996 28.0903 53.0068V51.3604C28.9611 51.346 29.8173 51.2918 30.6663 51.1943L30.8776 52.8299Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5622 53.4073C33.644 53.6384 32.704 53.8225 31.753 53.9597L31.5381 52.3278C32.4198 52.2014 33.2833 52.0281 34.1322 51.8151L34.5622 53.4073Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9621 52.3099C37.1022 52.6529 36.2205 52.9526 35.3206 53.2053L34.8906 51.6131C35.7213 51.3784 36.5375 51.1004 37.3317 50.7863L37.9621 52.3099Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2478 50.7465C40.4207 51.2123 39.5645 51.6347 38.6828 52.0102L38.0488 50.4901C38.8613 50.1399 39.6483 49.75 40.4171 49.3203L41.2478 50.7465Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2356 48.811C43.4923 49.3634 42.7199 49.8797 41.922 50.3563L41.0913 48.9302C41.8273 48.4897 42.5378 48.0131 43.2227 47.5004L44.2356 48.811Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3682 43.8178C48.7962 44.5435 48.1877 45.2404 47.5428 45.9011L46.3696 44.7385C46.9635 44.1247 47.5246 43.482 48.0529 42.8141L49.3682 43.8178Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4088 40.8428C50.9242 41.6587 50.3996 42.4458 49.8348 43.2041L48.5195 42.2003C49.0405 41.4999 49.5251 40.7705 49.9696 40.0195L51.4088 40.8428Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0123 37.6943C52.648 38.5428 52.2435 39.3696 51.799 40.1712L50.3599 39.348C50.7679 38.6078 51.1432 37.846 51.4784 37.0625L53.0123 37.6943Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9197 42.3084C53.3623 43.2472 52.7575 44.1534 52.1089 45.0272L50.5933 43.8718C51.1908 43.0666 51.7482 42.229 52.262 41.3624L53.9197 42.3084Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5723 12.2507L14.6434 13.3122C15.0515 12.9295 15.4778 12.5648 15.9223 12.2182L15.0041 11.0267C14.505 11.4131 14.0277 11.8211 13.5723 12.2507Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6909 14.1028L12.8896 15.0162C13.2357 14.5974 13.6037 14.1894 13.9863 13.8031L12.9151 12.7416C12.4888 13.1785 12.0808 13.6334 11.6909 14.1028Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91699 16.1538L11.2286 16.9048C11.5274 16.4282 11.848 15.9624 12.1869 15.5183L10.9882 14.6049C10.6092 15.1031 10.2522 15.6194 9.91699 16.1538Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20264 18.8078L10.6017 19.3818C10.8313 18.8836 11.079 18.3962 11.3523 17.9232L10.0406 17.1758C9.73823 17.7029 9.45768 18.2481 9.20264 18.8078Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26367 21.2989L9.7247 21.6888C9.89229 21.1472 10.0818 20.6165 10.2931 20.0965L8.89763 19.5225C8.65716 20.1002 8.44584 20.6923 8.26367 21.2989Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66992 23.844L9.17103 24.0425C9.26211 23.4973 9.3787 22.963 9.51351 22.4322L8.05249 22.0459C7.89946 22.6344 7.77194 23.2338 7.66992 23.844Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50169 29.1158L9.0028 28.9208C8.95179 28.3756 8.92264 27.8268 8.91535 27.2708H7.40332C7.40696 27.8954 7.43975 28.5092 7.50169 29.1158Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94206 31.7552L9.40308 31.3652C9.27556 30.8164 9.1699 30.2568 9.09339 29.6899L7.59229 29.8849C7.67973 30.5204 7.79632 31.145 7.94206 31.7552Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71505 34.2713L10.1141 33.7009C9.91739 33.1846 9.74615 32.6574 9.59677 32.123L8.13574 32.5094C8.30334 33.1087 8.49645 33.6936 8.71505 34.2713Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84167 36.7122L11.1533 35.9612C10.8801 35.4593 10.6323 34.943 10.4064 34.4159L9.00732 34.9864C9.25872 35.5785 9.53562 36.1526 9.84167 36.7122Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.254 38.9436L12.4564 38.0337C12.1284 37.5824 11.8224 37.1166 11.5382 36.64L10.2266 37.391C10.5435 37.9218 10.886 38.4417 11.254 38.9436Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9852 41.0124L14.0564 39.9509C13.6593 39.5357 13.284 39.0988 12.9269 38.6475L11.7246 39.5573C12.1217 40.0664 12.5444 40.5502 12.9852 41.0124Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9418 42.8107L15.8636 41.6229C15.4264 41.269 15.0074 40.8971 14.6066 40.5072L13.5391 41.5651C13.9836 42.002 14.4536 42.4172 14.9418 42.8107Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4819 9.00848L15.3564 10.1386C15.8774 9.76309 16.4166 9.40925 16.9741 9.0843L16.2563 7.84949C15.6442 8.21054 15.054 8.59688 14.4819 9.00848Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6152 10.2832L12.6318 11.2905C13.1127 10.8392 13.6155 10.406 14.1401 10.0016L13.2657 8.87146C12.6937 9.31556 12.1399 9.78493 11.6152 10.2832Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81104 12.6443L10.9514 13.5145C11.3595 13.0162 11.7931 12.536 12.2449 12.0811L11.2283 11.0737C10.7328 11.572 10.2592 12.0991 9.81104 12.6443Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53418 14.7999L8.78024 15.5112C9.13001 14.9479 9.50893 14.3991 9.90971 13.8756L8.77295 13.009C8.32845 13.5831 7.91674 14.1825 7.53418 14.7999Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15527 17.9624L8.48149 18.5076C8.75111 17.9191 9.04258 17.345 9.36321 16.7854L8.11715 16.0741C7.77102 16.6879 7.44675 17.3161 7.15527 17.9624Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12109 20.7283L7.50925 21.0966C7.70235 20.4575 7.9246 19.8329 8.176 19.2227L6.84978 18.6775C6.57288 19.3454 6.32877 20.0278 6.12109 20.7283Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47266 23.5553L6.89725 23.7431C7.00291 23.1004 7.13772 22.4685 7.29803 21.8475L5.90987 21.4792C5.73134 22.158 5.5856 22.8513 5.47266 23.5553Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19482 26.4977H6.63399C6.65221 25.8261 6.70322 25.1618 6.78701 24.5047L5.36243 24.3169C5.27134 25.0354 5.21304 25.7647 5.19482 26.4977Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30142 29.4007L6.72601 29.2165C6.66043 28.5775 6.62764 27.9276 6.624 27.274H5.18848C5.19212 27.9889 5.22855 28.7002 5.30142 29.4007Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79944 32.3254L7.1876 31.9571C7.03457 31.3108 6.9107 30.6537 6.81961 29.9857L5.39502 30.1698C5.49339 30.8992 5.6282 31.6177 5.79944 32.3254Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66454 35.1089L7.9944 34.5637C7.76122 33.9571 7.55718 33.3397 7.3823 32.7079L5.99414 33.0762C6.18724 33.7694 6.4095 34.4446 6.66454 35.1089Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92059 37.81L9.16665 37.0988C8.84603 36.5102 8.55091 35.9037 8.28494 35.2863L6.95508 35.8278C7.24655 36.5066 7.56718 37.1674 7.92059 37.81Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4917 40.2796L10.6321 39.4131C10.2459 38.886 9.8852 38.3372 9.54635 37.7739L8.30029 38.4852C8.67557 39.1026 9.06906 39.702 9.4917 40.2796Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4181 42.5684L12.4346 41.5611C11.9683 41.0737 11.5238 40.5646 11.1048 40.0338L9.96436 40.9003C10.4198 41.478 10.9044 42.0341 11.4181 42.5684Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5906 44.5509L14.4686 43.4207C13.9549 43.0091 13.4594 42.5723 12.9858 42.1101L11.9692 43.1175C12.4866 43.6229 13.0258 44.0995 13.5906 44.5509Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0767 7.18536L14.0094 8.3949C14.6069 7.96163 15.2263 7.55725 15.8639 7.18175L15.0951 5.86389C14.3992 6.27189 13.7252 6.71238 13.0767 7.18536Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55664 10.9328L8.77355 11.8607C9.24356 11.2866 9.73907 10.7378 10.2564 10.2143L9.17069 9.13831C8.60596 9.70878 8.06308 10.3081 7.55664 10.9328Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79541 13.1495L6.12892 13.9114C6.5297 13.2651 6.95962 12.6368 7.42234 12.0339L6.20543 11.106C5.69899 11.7631 5.22898 12.4419 4.79541 13.1495Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01709 17.0817L6.43804 17.6666C6.74409 16.9914 7.07928 16.3307 7.44727 15.688L6.11741 14.9261C5.71299 15.6266 5.34864 16.3451 5.01709 17.0817Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88428 20.136L5.36716 20.5296C5.58577 19.7966 5.84081 19.0817 6.12865 18.3813L4.7077 17.7964C4.39436 18.5546 4.1211 19.3381 3.88428 20.136Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17334 23.2518L4.6963 23.454C4.81654 22.7175 4.96956 21.9918 5.15538 21.2769L3.67249 20.8833C3.46846 21.656 3.30086 22.4467 3.17334 23.2518Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6416 26.498H4.17914C4.201 25.7289 4.25565 24.9671 4.35402 24.2161L2.83106 24.0139C2.7254 24.8335 2.66346 25.6603 2.6416 26.498Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00541 29.6971L4.52838 29.4985C4.45187 28.7655 4.41179 28.0218 4.40814 27.2708H2.87061C2.87425 28.0904 2.92161 28.8991 3.00541 29.6971Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56331 32.9174L5.04984 32.5239C4.87131 31.7873 4.72921 31.0327 4.62355 30.2709L3.10059 30.4695C3.20989 31.2963 3.36656 32.1159 3.56331 32.9174Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52489 35.9864L5.94584 35.4051C5.67622 34.7118 5.44304 34.0006 5.24265 33.2784L3.75977 33.672C3.97473 34.4591 4.22977 35.2318 4.52489 35.9864Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91331 38.958L7.24317 38.1962C6.87518 37.5246 6.53634 36.8314 6.23394 36.1201L4.81299 36.7014C5.14454 37.4741 5.51253 38.2287 5.91331 38.958Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65153 41.673L8.87208 40.7487C8.42758 40.1458 8.01223 39.5175 7.62966 38.8712L6.2998 39.6331C6.7188 40.3371 7.17059 41.0159 7.65153 41.673Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77864 44.1899L10.8644 43.114C10.3288 42.5579 9.82236 41.973 9.34507 41.3665L8.12451 42.2908C8.64553 42.9551 9.19569 43.587 9.77864 44.1899Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1768 46.3708L13.1132 45.1649C12.5229 44.6919 11.9582 44.1936 11.4153 43.6665L10.3296 44.7425C10.9198 45.3165 11.5319 45.8581 12.1768 46.3708Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8952 48.259L15.664 46.9412C14.9973 46.5404 14.3524 46.1035 13.7293 45.6414L12.793 46.8473C13.467 47.3528 14.1702 47.8221 14.8952 48.259Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31494 6.94711C8.98898 6.30443 9.69945 5.69425 10.4391 5.12378L11.4483 6.4308C10.767 6.95795 10.1148 7.51758 9.48813 8.10971L8.31494 6.94711Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33789 9.14921C5.91356 8.44153 6.52201 7.76275 7.16326 7.11646L8.33645 8.27906C7.74622 8.8748 7.18512 9.49943 6.65318 10.1493L5.33789 9.14921Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72656 11.326C2.21479 10.5281 2.74673 9.75904 3.31511 9.01526L4.6304 10.019C4.10574 10.7014 3.61751 11.4127 3.16573 12.1492L1.72656 11.326Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.43408 16.002C2.80571 15.168 3.22107 14.3556 3.67285 13.5685L5.11202 14.3917C4.69667 15.1174 4.3141 15.8684 3.96798 16.6338L2.43408 16.002Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 22.9309C0.892095 22.0246 1.08155 21.1292 1.31109 20.2518L2.91421 20.6779C2.70289 21.4867 2.528 22.3099 2.39684 23.1475L0.75 22.9309Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.579782 30.0109C0.481409 29.1118 0.430401 28.1984 0.426758 27.274H2.08817C2.09182 28.1261 2.13918 28.9674 2.22663 29.7978L0.579782 30.0109Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26216 36.911C1.93061 36.0589 1.63913 35.1888 1.39502 34.3006L2.99814 33.8745C3.22403 34.6941 3.49365 35.4993 3.79606 36.2828L2.26216 36.911Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79613 40.1712C3.3407 39.348 2.92534 38.4995 2.55371 37.6293L4.09125 37.0011C4.43373 37.8063 4.8163 38.5897 5.23529 39.348L3.79613 40.1712Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05197 45.9047C7.39251 45.226 6.76948 44.5111 6.18652 43.7637L7.50545 42.7635C8.04469 43.4496 8.62035 44.1103 9.22881 44.7385L8.05197 45.9047Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6697 50.3566C12.85 49.8656 12.0593 49.3348 11.2979 48.7643L12.3107 47.4609C13.0139 47.9881 13.7426 48.4791 14.5004 48.9304L13.6697 50.3566Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8441 51.9849C15.9879 51.613 15.1536 51.2014 14.3447 50.7465L15.1754 49.3203C15.9223 49.7391 16.6911 50.1183 17.4817 50.4649L16.8441 51.9849Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67383 7.09824C3.3005 6.32557 3.96361 5.58541 4.6668 4.88135L5.94929 6.15227C5.3044 6.80217 4.6923 7.48457 4.11299 8.19585L2.67383 7.09824Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8315 10.752L16.7497 11.9434C17.1906 11.6257 17.6496 11.3297 18.1196 11.0516L17.3618 9.75183C16.8371 10.0623 16.3271 10.3981 15.8315 10.752Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5538 17.1758L44.2422 17.9268C44.5191 18.4142 44.7778 18.9161 45.011 19.4288L46.41 18.8583C46.1514 18.2806 45.8635 17.7174 45.5538 17.1758Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3734 12.9872L41.3022 14.0487C41.6957 14.4495 42.071 14.8647 42.4281 15.2979L43.6304 14.3881C43.2369 13.9007 42.8143 13.4349 42.3734 12.9872Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4237 11.2505L39.502 12.4384C39.9319 12.7742 40.3472 13.1316 40.7444 13.5035L41.8155 12.442C41.371 12.0268 40.9083 11.6296 40.4237 11.2505Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2271 9.75183L37.4692 11.0516C37.9538 11.3405 38.4238 11.6474 38.8793 11.9723L39.801 10.7845C39.2983 10.4162 38.77 10.0732 38.2271 9.75183Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.903 8.57129L35.3237 9.95414C35.8265 10.1708 36.3184 10.4091 36.7957 10.6654L37.5535 9.36562C37.0179 9.08038 36.4678 8.8132 35.903 8.57129Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3928 7.68347L33.0029 9.13131C33.5458 9.28656 34.0777 9.46348 34.5988 9.66206L35.1781 8.27921C34.5988 8.05175 34.0012 7.85317 33.3928 7.68347Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.842 7.1344L30.6416 8.61834C31.1845 8.69778 31.7201 8.80248 32.2447 8.92885L32.6382 7.48102C32.048 7.34381 31.4504 7.22466 30.842 7.1344Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1895 6.91455V8.41294C28.7542 8.42377 29.3153 8.45987 29.8654 8.52125L30.0658 7.0337C29.4464 6.96871 28.8198 6.92899 28.1895 6.91455Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6313 7.3618L25.8281 8.84936C26.3637 8.79159 26.9102 8.75909 27.4567 8.74826V7.24988C26.8446 7.26071 26.2325 7.29681 25.6313 7.3618Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9541 7.48477L23.3439 8.9326C23.8868 8.80262 24.437 8.69792 24.9944 8.61488L24.7977 7.12732C24.1783 7.22119 23.5626 7.34034 22.9541 7.48477Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4614 8.25755L21.0371 9.64401C21.5435 9.45265 22.0609 9.27934 22.5892 9.13131L22.1957 7.68347C21.6091 7.84956 21.0298 8.04092 20.4614 8.25755Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.043 9.36945L18.8008 10.6693C19.2927 10.4057 19.7991 10.1602 20.3165 9.93992L19.7408 8.55347C19.1579 8.79899 18.5931 9.07339 18.043 9.36945Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.323 18.8905L46.9932 19.4321C47.2373 20.0278 47.4522 20.6344 47.6381 21.2554L49.0262 20.8871C48.8258 20.2084 48.589 19.5404 48.323 18.8905Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4704 16.0741L46.228 16.7854C46.5559 17.3595 46.8583 17.9516 47.1316 18.5582L48.4615 18.013C48.1627 17.3522 47.8311 16.7023 47.4704 16.0741Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8748 13.6624L44.7344 14.5289C45.1242 15.0416 45.4886 15.5723 45.8311 16.1212L47.0771 15.4099C46.7018 14.8069 46.3011 14.2256 45.8748 13.6624Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9399 11.4348L42.9233 12.4422C43.3897 12.9115 43.8306 13.4062 44.2496 13.9189L45.39 13.0523C44.9345 12.4891 44.4499 11.9511 43.9399 11.4348Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7753 9.51025L40.9009 10.6367C41.4073 11.0339 41.8992 11.4527 42.3655 11.8932L43.3821 10.8859C42.8683 10.4057 42.3328 9.94713 41.7753 9.51025Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3345 7.84949L38.6167 9.0843C39.1887 9.42369 39.7425 9.78475 40.2781 10.1747L41.1562 9.04459C40.5696 8.61854 39.9648 8.22138 39.3345 7.84949Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7557 6.54236L36.2056 7.8566C36.7994 8.11295 37.3788 8.39097 37.9435 8.69787L38.6613 7.46305C38.0419 7.13088 37.4079 6.82037 36.7557 6.54236Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9678 5.56055L33.5962 6.93617C34.2374 7.1167 34.8641 7.32612 35.4799 7.56441L36.03 6.25017C35.356 5.9866 34.671 5.75913 33.9678 5.56055Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1328 4.95776L30.9434 6.3695C31.5846 6.46337 32.2186 6.58613 32.838 6.73777L33.2096 5.36215C32.5283 5.19606 31.836 5.06247 31.1328 4.95776Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1895 4.71924V6.1418C28.8562 6.15263 29.5157 6.19596 30.1679 6.26817L30.3573 4.85644C29.6432 4.77701 28.9181 4.73007 28.1895 4.71924Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3589 5.36521L25.5447 6.77694C26.1787 6.70834 26.8199 6.66863 27.4721 6.65779V5.23523C26.758 5.24606 26.0511 5.28939 25.3589 5.36521Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3818 5.3618L22.7535 6.73743C23.3911 6.58217 24.0433 6.4558 24.7027 6.36193L24.5169 4.9502C23.7919 5.0549 23.0814 5.1921 22.3818 5.3618Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6167 6.2285L20.1669 7.54636C20.7644 7.31889 21.3765 7.11309 21.9995 6.93617L21.6279 5.56055C20.9429 5.75191 20.2725 5.97576 19.6167 6.2285Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9351 7.46647L17.6528 8.70129C18.2321 8.38717 18.8297 8.09832 19.4418 7.83836L18.8916 6.52051C18.2212 6.80574 17.569 7.11986 16.9351 7.46647Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2828 18.0671L48.8618 18.6484C49.1387 19.3308 49.3865 20.0313 49.6014 20.7426L51.088 20.349C50.8511 19.5691 50.5852 18.8109 50.2828 18.0671Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7152 12.2689L46.4946 13.1932C46.9428 13.7817 47.3618 14.3919 47.7516 15.0202L49.0815 14.2583C48.6588 13.5759 48.2034 12.908 47.7152 12.2689Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5799 9.81323L44.4941 10.8892C45.0297 11.4272 45.5362 11.994 46.0135 12.5825L47.234 11.6582C46.713 11.0156 46.1628 10.3981 45.5799 9.81323Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1893 7.69019L42.2529 8.89611C42.8359 9.35105 43.397 9.83486 43.9362 10.3403L45.022 9.26439C44.4354 8.71197 43.8269 8.18483 43.1893 7.69019Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4963 5.86023L39.7275 7.17808C40.3834 7.56442 41.021 7.98324 41.6331 8.42734L42.5694 7.22142C41.9027 6.7376 41.2104 6.28267 40.4963 5.86023Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6444 4.4231L37.0542 5.83122C37.7355 6.12367 38.4023 6.44501 39.0508 6.79885L39.8196 5.48099C39.1127 5.09105 38.3877 4.74083 37.6444 4.4231Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4404 2.68262L31.2363 4.19184C31.9723 4.30015 32.701 4.44097 33.4115 4.61427L33.8086 3.14477C33.0362 2.95341 32.2419 2.79816 31.4404 2.68262Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1895 2.42273V3.94639C28.9546 3.95722 29.7124 4.00777 30.4593 4.09082L30.6634 2.5816C29.8472 2.49133 29.0238 2.43717 28.1895 2.42273Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7803 3.14498L22.1774 4.61448C22.9097 4.43757 23.6567 4.28953 24.4145 4.18122L24.2177 2.672C23.3907 2.79115 22.5782 2.95001 21.7803 3.14498Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7314 4.10509L19.318 5.51321C20.003 5.24964 20.7062 5.01496 21.424 4.81277L21.0268 3.34326C20.2435 3.5599 19.4784 3.81625 18.7314 4.10509Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7764 5.47709L16.5451 6.79495C17.2082 6.43389 17.8932 6.10172 18.5964 5.80204L18.0098 4.39392C17.2447 4.72248 16.4978 5.08354 15.7764 5.47709Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7422 1.15908C25.6385 1.05798 26.5493 1.00021 27.4711 0.98938V2.6358C26.6222 2.65025 25.7842 2.70079 24.9571 2.79466L24.7422 1.15908Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7983 1.8628C18.6436 1.53424 19.5108 1.2454 20.3925 0.999878L20.8224 2.59214C20.0099 2.81961 19.212 3.08318 18.4323 3.38646L17.7983 1.8628Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5532 3.3795C15.3694 2.93179 16.211 2.5238 17.0745 2.15552L17.7085 3.67918C16.9105 4.01496 16.1345 4.39407 15.3839 4.80567L14.5532 3.3795Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3776 17.2402C52.7201 18.0779 53.0225 18.9408 53.2849 19.8182L51.6781 20.2442C51.4376 19.4355 51.1607 18.6411 50.8438 17.8685L52.3776 17.2402Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5954 13.7166C52.0581 14.5253 52.4844 15.3594 52.8633 16.2151L51.3258 16.8433C50.9724 16.0526 50.5825 15.2835 50.1562 14.5398L51.5954 13.7166Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6563 10.7958C50.2065 11.5179 50.7239 12.2689 51.2012 13.0488L49.762 13.872C49.3211 13.1571 48.8475 12.4639 48.3374 11.7959L49.6563 10.7958Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3065 8.09839C47.966 8.75912 48.589 9.45596 49.1756 10.1817L47.8567 11.1818C47.3138 10.5139 46.7381 9.87118 46.1333 9.26099L47.3065 8.09839Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7174 3.76208C42.5263 4.23507 43.306 4.75138 44.0602 5.3038L43.0473 6.60721C42.3514 6.09812 41.6336 5.62514 40.8867 5.18826L41.7174 3.76208Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5805 2.1842C39.4221 2.54165 40.2419 2.94242 41.0398 3.3793L40.2091 4.80547C39.4768 4.4047 38.7189 4.03642 37.9429 3.70425L38.5805 2.1842Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2 0.999878C36.1072 1.25262 36.9925 1.54869 37.8597 1.88808L37.2221 3.41174C36.4242 3.10123 35.608 2.82683 34.77 2.59575L35.2 0.999878Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7606 0.28186C32.6715 0.411841 33.5641 0.588757 34.4422 0.805392L34.0123 2.39765C33.2034 2.19907 32.38 2.0366 31.542 1.91745L31.7606 0.28186Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1895 0C29.1331 0.0144423 30.0658 0.0722113 30.9876 0.180528L30.769 1.8125C29.9201 1.71502 29.0602 1.66086 28.1931 1.64642V0H28.1895Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5675 35.037L45.1721 34.4629C44.9498 34.9756 44.7093 35.4738 44.4434 35.9613L45.755 36.7123C46.0465 36.1671 46.3197 35.611 46.5675 35.037Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4556 32.5058L45.9946 32.1195C45.8415 32.6719 45.663 33.2135 45.459 33.7443L46.8581 34.3183C47.084 33.7262 47.2844 33.1232 47.4556 32.5058Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9917 29.9351L46.4906 29.7366C46.4141 30.289 46.3121 30.8306 46.1846 31.3649L47.6456 31.7549C47.7913 31.1591 47.9079 30.5526 47.9917 29.9351Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1881 27.274H46.676C46.6724 27.8481 46.6396 28.415 46.585 28.9746L48.0861 29.1732C48.148 28.545 48.1844 27.9131 48.1881 27.274Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0387 24.6637L46.5376 24.8587C46.6032 25.4003 46.6469 25.9491 46.6651 26.5015H48.1772C48.1589 25.8805 48.1152 25.2667 48.0387 24.6637Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.755 21.9778L46.2939 22.3641C46.436 22.9057 46.5526 23.4581 46.6437 24.0214L48.1448 23.8264C48.0428 23.2018 47.9116 22.5844 47.755 21.9778Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6109 35.8816L47.2847 35.3364C47.026 35.9394 46.7381 36.5279 46.4248 37.0984L47.6709 37.8097C48.017 37.185 48.3303 36.5423 48.6109 35.8816Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5986 33.0762L48.2104 32.7079C48.0282 33.3578 47.8169 33.9933 47.5801 34.6143L48.9063 35.1595C49.1686 34.4807 49.4018 33.7875 49.5986 33.0762Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1918 30.2277L48.7672 30.0399C48.6761 30.6898 48.5559 31.3289 48.4028 31.9571L49.791 32.3254C49.9586 31.6358 50.0898 30.9389 50.1918 30.2277Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4032 27.274H48.9677C48.9641 27.9492 48.9276 28.6136 48.8584 29.2707L50.283 29.4584C50.3595 28.7399 50.3996 28.0106 50.4032 27.274Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2395 24.3783L48.8149 24.5624C48.8915 25.1979 48.9425 25.8442 48.9607 26.4977H50.3998C50.378 25.7828 50.3233 25.0751 50.2395 24.3783Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0942 21.3782L48.7061 21.7464C48.8737 22.3855 49.0085 23.0354 49.1178 23.6962L50.5424 23.512C50.4258 22.7899 50.2764 22.0786 50.0942 21.3782Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7528 36.763L49.3319 36.1781C49.0368 36.8677 48.7052 37.5429 48.3481 38.1964L49.678 38.9582C50.0715 38.247 50.4286 37.514 50.7528 36.763Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8354 33.6685L50.3525 33.2749C50.1448 34.0187 49.9043 34.7444 49.6274 35.4593L51.0484 36.0442C51.3472 35.2716 51.6131 34.4772 51.8354 33.6685Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4879 30.5275L50.9649 30.3253C50.8629 31.0691 50.7208 31.802 50.5459 32.5205L52.0324 32.9141C52.2219 32.1378 52.3749 31.3399 52.4879 30.5275Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7207 27.274H51.1832C51.1795 28.0467 51.1358 28.8085 51.0557 29.5631L52.5786 29.7653C52.6697 28.9421 52.7171 28.1117 52.7207 27.274Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5347 24.0824L51.0117 24.281C51.1028 25.0103 51.1575 25.7541 51.1793 26.5015H52.7169C52.695 25.6819 52.6331 24.8767 52.5347 24.0824Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5786 20.7319L51.0957 21.1255C51.2888 21.8548 51.4455 22.6022 51.5657 23.3604L53.0887 23.1618C52.9575 22.3386 52.7863 21.5263 52.5786 20.7319Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9108 30.8486C54.7832 31.7621 54.612 32.6647 54.3934 33.5457L52.7866 33.1196C52.9834 32.3037 53.1437 31.4732 53.2603 30.632L54.9108 30.8486Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1651 27.274C55.1614 28.2236 55.1068 29.1588 55.0048 30.0831L53.3579 29.8664C53.449 29.0143 53.5 28.1514 53.5036 27.274H55.1651Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4276 20.0205C55.6644 20.9195 55.8538 21.833 55.9996 22.7645L54.3491 22.9776C54.2143 22.1182 54.0394 21.2734 53.8208 20.4466L55.4276 20.0205Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8313 15.8109C31.0813 15.8109 34.0252 17.0854 36.1566 19.1435L31.9921 23.1693C30.9282 22.1402 29.4563 21.5012 27.8313 21.5012C24.5813 21.5012 21.9435 24.0502 21.9435 27.1914C21.9435 30.3362 24.5777 32.8817 27.8313 32.8817C29.4563 32.8817 30.9282 32.2462 31.9921 31.2136L36.1566 35.2358C34.0252 37.2974 31.0813 38.5683 27.8313 38.5683C21.3277 38.5683 16.0557 33.4738 16.0557 27.1878C16.0557 20.9054 21.3277 15.8109 27.8313 15.8109Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.714ab87d15fc45880adb447d94c50d34.svg";
export { ForwardRef as ReactComponent };